<template>
    <div>
        <BlacklistHeader view-type="wildcard"/>

        <div class="topbar pl-sm-5">
            <div class="topbar__inner">
                <div class="topbar__key">
                    <header class="topbar__key__header form-control-wrapper flex-wrap pl-0">
                        <input class="form-control form-control--big w-100 w-sm-auto mv-50 mr-sm-3 mb-3 mb-sm-0" v-model="newKeyword" @keyup.enter="addKeyword">
                        <button class="button w-100 w-sm-auto" @click="addKeyword">Add Keyword</button>
                    </header>
                </div>
            </div>
        </div>

        <div class="main-table-wrapper overflow-auto">
            <div class="main-table">
                <Grid
                    :columns="columns"
                    :data="items"
                    :has-filters="true"
                    :page-length="parseInt(pageLength)"
                    :total-rows-count="totalRowsCount"
                    :sort="sort"
                    :currentPage="currentPage"
                    v-on:changePage="changePage"
                    v-on:changeFilters="changeFilters"
                    v-on:action="gridAction"
                >
                </Grid>
            </div>
        </div>
    </div>
</template>

<script>
import Grid from "../../../../frontend/src/components/Grid"
import grid from "../../../../frontend/src/mixins/grid"
import blacklistedClientsWildcardService from "@/services/blacklisted-clients-wildcard.service";
import BlacklistHeader from "@/components/clients/BlacklistHeader.vue";

export default {
    components: {
        BlacklistHeader,
        Grid,
    },

    mixins: [grid],

    data() {
        return {
            newKeyword: "",

            columns: [
                {
                    label: 'Keyword',
                    name: 'word',
                    filter: 'text',
                },
                {
                    name: 'actions',
                    label: 'Actions',
                    component: 'Actions',
                }
            ],

            getListMethod: blacklistedClientsWildcardService.getKeywords
        }
    },

    mounted() {
        this.getList()
    },

    methods: {
        gridAction(params) {
            if (params.action === 'delete') {
                this.delete(params.rowId)
            }
        },

        delete(id) {
            if (confirm("Delete keyword?")) {
                blacklistedClientsWildcardService.delete(id).then(() => {
                    this.getList()
                })
            }
        },

        addKeyword() {
            if (this.newKeyword.length) {
                let form = {
                    word: this.newKeyword,
                };

                blacklistedClientsWildcardService.save(0, form).then(() => {
                    this.newKeyword = ""
                    this.getList()
                })
            }
        },
    }
}
</script>

<style scoped>

</style>
